import React from 'react'
import './styles.scss'
import { Button } from 'components/Form'

function downloadHandbook(url) {
  try {
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.click()
  } catch (error) {
    console.error(error)
  }
}

/**
 * Handbook button
 * @param {object} props
 * @param {string} props.buttonText
 * @param {string} props.handbookUrl
 * @param {string} [props.text]
 * @param {string} [props.containerClass]
 * @param {string} [props.buttonClass]
 * @param {string} [props.textClass]
 *
 * @returns {Component}
 */
function HandbookButton(props) {
  const {
    containerClass = '', buttonClass = '', textClass = '',
    text, buttonText, handbookUrl
  } = props

  if (!handbookUrl) return null

  return (
    <div className={`handbook_button_container ${containerClass}`}>
      {text && <span className={textClass}>{text}</span>}
      <Button
        primary
        small
        className={buttonClass}
        value={buttonText}
        onClick={()=> downloadHandbook(handbookUrl)}
      />
    </div>
  )
}

export default HandbookButton